const { create } = require("axios");

const api = create({
  baseURL: `${process.env.API_ENDPOINT}/api/v2`,
  headers: {
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest",
    "Accept-Language": "id"
  }
});

api.setToken = token => {
  if (!!token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common["Authorization"];
  }
};

module.exports = api;



// WEBPACK FOOTER //
// ./helpers/api.js